export const LogscordLandingProductHighlights = [
    {
        icon: "travel_explore",
        titleKey: "landing.highlight.truth.title",
        descriptionKey: "landing.highlight.truth.description",
    },
    {
        icon: "history",
        titleKey: "landing.highlight.time.title",
        descriptionKey: "landing.highlight.time.description",
    },
    {
        icon: "verified_user",
        titleKey: "landing.highlight.proof.title",
        descriptionKey: "landing.highlight.proof.description",
    },
    {
        icon: "lock",
        titleKey: "landing.highlight.control.title",
        descriptionKey: "landing.highlight.control.description",
    },
];
export const LogscordLandingUseCases = [
    {
        icon: "gavel",
        labelKey: "landing.use.moderation.label",
        titleKey: "landing.use.moderation.title",
        descriptionKey: "landing.use.moderation.description",
    },
    {
        icon: "groups",
        labelKey: "landing.use.community.label",
        titleKey: "landing.use.community.title",
        descriptionKey: "landing.use.community.description",
    },
    {
        icon: "monitoring",
        labelKey: "landing.use.operations.label",
        titleKey: "landing.use.operations.title",
        descriptionKey: "landing.use.operations.description",
    },
];
export const LogscordLandingTestimonials = [
    {
        quoteKey: "landing.testimonials.mika.quote",
        nameKey: "landing.testimonials.mika.name",
        titleKey: "landing.testimonials.mika.title",
        metricKey: "landing.testimonials.mika.metric",
        avatar: "MK",
    },
    {
        quoteKey: "landing.testimonials.lena.quote",
        nameKey: "landing.testimonials.lena.name",
        titleKey: "landing.testimonials.lena.title",
        metricKey: "landing.testimonials.lena.metric",
        avatar: "LN",
    },
    {
        quoteKey: "landing.testimonials.nox.quote",
        nameKey: "landing.testimonials.nox.name",
        titleKey: "landing.testimonials.nox.title",
        metricKey: "landing.testimonials.nox.metric",
        avatar: "NX",
    },
];
export const LogscordLandingPreviewSidebarItems = [
    { icon: "dashboard", labelKey: "public.preview.sidebar.overview", active: false },
    { icon: "timeline", labelKey: "public.preview.sidebar.timeline", active: true },
    { icon: "manage_search", labelKey: "public.preview.sidebar.investigations", active: false },
    { icon: "group", labelKey: "public.preview.sidebar.users", active: false },
    { icon: "settings", labelKey: "public.preview.sidebar.settings", active: false },
];
export const LogscordLandingPreviewMetrics = [
    { icon: "priority_high", value: "5", labelKey: "public.preview.metrics.critical" },
    { icon: "person_search", value: "1", labelKey: "public.preview.metrics.actor" },
    { icon: "schedule", value: "11:11", labelKey: "public.preview.metrics.instant" },
];
export const LogscordLandingTimelineRows = [
    { time: "11:11:42", type: "member_ban_add", icon: "gavel", textKey: "public.preview.row.ban", tagKey: "public.preview.tag.ban" },
    { time: "11:11:34", type: "channel_delete", icon: "delete", textKey: "public.preview.row.channel_delete", tagKey: "public.preview.tag.deletion" },
    { time: "11:11:22", type: "message_create", icon: "chat", textKey: "public.preview.row.message", tagKey: "public.preview.tag.message" },
    { time: "11:11:09", type: "member_role_update", icon: "local_offer", textKey: "public.preview.row.role", tagKey: "public.preview.tag.role" },
    { time: "11:10:58", type: "voice_join", icon: "settings_voice", textKey: "public.preview.row.voice", tagKey: "public.preview.tag.voice" },
];
//# sourceMappingURL=landing.js.map